const { Observable } = rxjs;

/**
 * Sends a request to Swift with a unique identifier.
 * 
 * @param {string} name - The name of the method to call in Swift.
 * @param {Object} data - The parameters to pass to the method.
 * @param {string} callback - The name of the callback function to handle the response.
 * @param {string} [iosHandler='Connect'] - The name of the iOS message handler.
 */
const sendMessageToSwift = (name, data, callback, iosHandler = 'Connect') => {
  const params = {
    name: name,
    parameters: data,
    callbackName: callback
  }
  window.webkit.messageHandlers[iosHandler].postMessage(JSON.stringify(params));
}

/**
 * Observable to get the soft token status on iOS.
 */
async function getSoftTokenStatusiOs() {
  const callbackPromise = new Promise(resolve => {
    window.handleIOSSoftTokenActiveCb = (response) => {
        const parsedResponse = JSON.parse(response);
        resolve(parsedResponse.action);
    };
  
    sendMessageToSwift('isSoftTokenActive', '{}', 'handleIOSSoftTokenActiveCb');
  });

  const result = await callbackPromise;
  return result;
};

/**
 * Observable to check if transmit is allowed on iOS.
 */
async function iosIsTransmitAllowed() {
  const callbackPromise = new Promise(resolve => {
    window.handleIOSTransmitAllowedCb = (response) => {
        const parsedResponse = JSON.parse(response);
        resolve(parsedResponse.action);
    };

    sendMessageToSwift('isTransmitAllowed', '{}', 'handleIOSTransmitAllowedCb');
  });

  const result = await callbackPromise
  return result;
};

/**
 * Observable to get the FTT (Feature Toggle Token Interface) on iOS.
 */
const getProvideFttiOs = new Observable(subscriber => {
  window.handleIOSFttCb = (res) => {
    const response = JSON.parse(res);
    if (response.status === "true") {
      subscriber.next(response.params)
    } else {
      subscriber.next({ token: "", typeOTP: "", date: "" })
    }
    subscriber.complete();
  };
  sendMessageToSwift('provideFtt', null, 'handleIOSFttCb');
});

/**
 * Observable to get a token transmit on iOS.
 */
const iosTokenTransmit = new Observable(subscriber => {
  window.tokenTransmitCbResponse = res => {
    const response = JSON.parse(res);
    if (response.status === "true") {
      subscriber.next(response.params)
    } else {
      subscriber.next({ token: "", typeOTP: "", date: "" })
    }
    subscriber.complete();
  };

  const tokenParameters = {
    codeChallenge : localStorage.getItem("codeChallenge")??'',
    functionalityId : functionality_id,
    functionalityDesc: functionality_description,
    additionalData : null,
    isFunctionalityEnabled: true
  };
  sendMessageToSwift('superTokenTransmit', tokenParameters, 'tokenTransmitCbResponse')
});

/**
 * Checks if a feature is enabled on iOS.
 * 
 * @returns {Promise<boolean>} - A promise that resolves to true if the feature is enabled, otherwise false.
 */
 const iosIsFeatureEnabled = async () => {
  const fttObject = await getProvideFttiOs.toPromise();
  const feature = validateFeature(fttObject, 'accountStatements');
  return feature.isEnabled;
}

/**
 * Observable to get the legacy token on iOS.
 */
async function iosTokenLegacy() {
  const promise = new Promise(resolve => {
    window.tokenLegacyCbResponse = (res) => {
      const response = JSON.parse(res);
      if (response.status === "true") {
        resolve(response.params);
      } else {
        resolve({ token: "", typeOTP: "", date: "" });
      }
    };
    sendMessageToSwift('superToken', null, 'tokenLegacyCbResponse', 'TokenManager');
  });


  const result = await promise;
  return result;
};

/**
 * Observable to get the active token status on iOS.
 */
const iospromiseActiveToken = new Observable(subscriber => {
  window.getEstatusTokenResponse = function (code) {
    var obj = JSON.parse(code);
    subscriber.next(obj.params.estatusToken === '1');
    subscriber.complete();
  };
  const parameters =  {
    code_challenge: localStorage.getItem("codeChallenge"),
    functionality_description: functionality_description,
    functionality_id: functionality_id
  }
  sendMessageToSwift('getEstatusTokenEDC', parameters, 'getEstatusTokenResponse')
})